<template>
  <section class="redirect-to-store-section">
    <nuxt-img
      src="img/main/usimsaicon.svg"
      class="redirect-usimsa-og-img"
      width="50px"
      height="50px"
      alt="Redirect to Store"
    />
    <p>앱으로 이동중입니다...</p>
    <p class="redirect-text">앱이 열리지 않으면 아래 버튼을 눌러 웹에서 이용해 주세요.</p>
    <CtaButton
      w-full
      size="xl"
      text="웹에서 계속 이용하기"
      type="primary"
      bottom-fixed
      @click-button="goBackHome"
    />
  </section>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})

const goBackHome = () => {
  navigateTo('/')
}

const openApp = () => {
  const ua = navigator.userAgent.toLowerCase()
  const isAndroid = ua.includes('android')
  const isIOS = /iphone|ipad|ipod/.test(ua)
  const schemeUrl = 'appusimsa://'
  const fallbackUrl = isIOS
    ? 'https://apps.apple.com/kr/app/유심사-글로벌-esim-서비스/id1635360522'
    : isAndroid
      ? 'https://play.google.com/store/apps/details?id=com.gadgetkorea.usimsa&hl=ko'
      : '/'

  let fallbackTimer: number

  const cancelFallback = () => {
    clearTimeout(fallbackTimer)
  }

  // 브라우저가 백그라운드로 가면 앱 실행된 걸로 판단
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) cancelFallback()
  })
  document.addEventListener('pagehide', cancelFallback)

  // 앱 실행 시도
  setTimeout(() => {
    window.location.href = schemeUrl

    // fallback 예약
    fallbackTimer = window.setTimeout(() => {
      window.location.href = fallbackUrl
    }, 1600)
  }, 100)
}

onMounted(() => {
  openApp()
})
</script>

<style scoped lang="scss">
.redirect-to-store-section {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 40px;
  p {
    @include body7-medium;
    margin-top: 12px;
    color: $gray-500;
  }
  .redirect-text {
    position: fixed;
    bottom: 120px;
    @include footnote2-medium;
    color: $gray-400;
  }
}
</style>
